export interface CardProps {
  header?: string;
  itemsPerRow: number;
  data: { key: string; value: string }[];
  headerFontSize?: number;
  headerBold?: boolean;
  headerAlignment?: 'center' | 'left' | 'right';
  backgroundColor?: string;
  textColor?: string;
  keyColor?: string;
  valueColor?: string;
  keyFontSize?: number;
  valueFontSize?: number;
  layout?: string | any;
  tableFontSize?: number;
  valuesOnNewLine?: boolean;
}

export function createCard({
  header,
  itemsPerRow,
  data,
  headerFontSize,
  headerBold,
  headerAlignment = 'left',
  backgroundColor = 'white',
  textColor,
  keyColor,
  valueColor,
  keyFontSize,
  valueFontSize,
  layout,
  tableFontSize,
  valuesOnNewLine = false,
}: CardProps) {
  const body = [];

  // Header
  if (header) {
    body.push([
      {
        text: header,
        colSpan: itemsPerRow,
        alignment: headerAlignment,
        fillColor: backgroundColor,
        bold: headerBold ?? true,
        fontSize: headerFontSize ?? undefined,
        color: textColor,
      },
      ...Array(itemsPerRow - 1).fill(''),
    ]);
  }

  // Data rows
  for (let i = 0; i < data.length; i += itemsPerRow) {
    const row = [];
    for (let j = 0; j < itemsPerRow; j++) {
      const dataIndex = i + j;
      if (dataIndex < data.length) {
        const item = data[dataIndex];
        const valueText = { text: item.value, color: valueColor, margin: [4, valuesOnNewLine ? 4 : 0], fontSize: valueFontSize };
        row.push({
          text:
            item.key === ''
              ? [valueText]
              : [{ text: `${item.key}:`, color: keyColor, fontSize: keyFontSize }, { text: valuesOnNewLine ? '\n' : ' ' }, valueText],
          fillColor: backgroundColor,
          color: textColor,
          alignment: item.value === 'N/A' ? 'center' : 'left',
          ...(tableFontSize ? { fontSize: tableFontSize } : {}),
        });
      } else {
        row.push({ text: '', fillColor: backgroundColor });
      }
    }
    body.push(row);
  }

  return {
    table: {
      headerRows: 1,
      widths: Array(itemsPerRow).fill('*'), // Equal width columns
      body: body,
    },
    margin: 10,
    layout: layout,
  };
}
